import {
	VALIDATE_EMAIL_REG_EXP,
	VALIDATE_PHONE_NUMBER_REG_EXP,
} from '@zyro-inc/site-modules/constants/regex';

// For new typescript components, use validateString.ts instead.
export const validateInput = ({
	value = '',
	validation,
	validationMessages,
	name,
}) => {
	const validationErrors = [];

	if (validation.includes('required') && !value.replace(/ /g, '')) {
		validationErrors.push({
			message: validationMessages.required,
			name,
		});
	}

	if (!value.replace(/ /g, '')) {
		return validationErrors;
	}

	if (validation.includes('email') && !VALIDATE_EMAIL_REG_EXP.test(value)) {
		validationErrors.push({
			message: validationMessages.email,
			name,
		});
	}

	// TODO this validation type needs to be replaced once schema is updated
	if (validation.includes('phone') && !VALIDATE_PHONE_NUMBER_REG_EXP.test(value)) {
		validationErrors.push({
			message: validationMessages.phone,
			name,
		});
	}

	return validationErrors;
};
